/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Cookies } from 'react-cookie'
// import PropTypes from 'prop-types';
// import AddIcon from '../Icon/AddIcon';
import ic_files_empathy from '../../images/ic_files_empathy.svg'
import { useHistory, useLocation, useParams } from "react-router-dom";
import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
// import TableSortLabel from '@material-ui/core/TableSortLabel';
// import TableHead from '@material-ui/core/TableHead';
// import Paper from '@material-ui/core/Paper';
// import SearchIcon from '@material-ui/icons/Search';
import { Badge, Button, Media, ListGroup, DropdownButton, Dropdown } from 'react-bootstrap'
// import { Request } from '../../service'
// import { renewToken } from '../../middleware';
import { Roles } from '../../utils/constants';
// import userManager from '../../middleware/userManager';
import Header from '../layout/Header';
// import { Method, ServicePath } from '../../utils';

import { Icon } from '@material-ui/core';
// import FileDownload from '@material-ui/icons/FontDownload';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Swal from 'sweetalert2';

import { Method, ServicePath } from '../../utils';

import { Request, deleteUserGroup, deleteUser } from '../../service'
const cookies = new Cookies()


const UserDetail = () => {

    let history = useHistory();
    let location = useLocation();
    let { id } = useParams();
    const [groups, setGroup] = useState([]);
    // const [error, setError] = useState(null);
    // const [isLoaded, setIsLoaded] = useState(false);

    var { user } = location.state
    // const [error, setError] = useState(null);
    // const [isLoaded, setIsLoaded] = useState(false);

    function requestRole() {
        Request(Method.GET, ServicePath.UserRole + '/' + id, {}).then(res => {
            if (res.code === 200) {
                // setIsLoaded(true);
                console.log(res.result)
                setGroup(res.result.groups)
                // setList(res.result)
            }
        }).catch(err => {
            console.log(err)
            // setIsLoaded(true);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
            // setError(error);
        })
    }
    function handleClickBack() {
        history.push("/manage-user");
        history.go()
    }

    useEffect(() => {
        requestRole()
    }, [])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // console.log(value);
    const handleDeleteAcc = emp => {
        Swal.fire({
            title: 'Are you sure?',
            // text: "You want to be able to delete this!",
            text: `You want to be able to delete ${emp.firstname} ${emp.lastname}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#cad998',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteUser(emp.employeeid).then(res => {
                    if (res.code === 200) {
                        history.push('/manage-user')
                        history.go(0)
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        })

    }
    const handleGroup = g => {
        console.log(g)
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to be able to delete this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#cad998',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    group_id: g.group_id,
                    employeeid: user.employeeid
                }

                deleteUserGroup(data).then(res => {
                    console.log(res)
                    requestRole()
                    // var u = user
                    // const filteredGroup = u.groups.filter((item) => item.group_id !== g.group_id);
                    // u.groups = filteredGroup
                    // user.groups = filteredGroup
                    // location.state.user.groups = filteredGroup
                    // location.state.user = u
                    // setIsLoaded(false)
                }).catch(err => {
                    console.log(err)
                })
            }
        })

    }

    return (
        <>
            {/* 
      <div role="main" className="main-content" id="panel"  >
        <Container fluid>
          {contentRender()}
        </Container>
      </div> */}
            <Header />

            <div className="container">
                <div className="row">

                    {/* <Sidebar /> */}
                    <main role="main" className="col-md-12 ml-sm-auto col-lg-12 px-md-4 mb-5">
                        <div className="row pt-3 pb-2 mb-3">
                            {cookies.get('profile') ? (cookies.get('profile').super_role === Roles.SUPER ?
                                <div className="d-flex justify-content-between" >

                                    <div className="flex-column">
                                        <Button onClick={handleClickBack} variant="link" className="p-0" >
                                            <p className="text-muted mb-1" style={{ fontSize: "14px" }} >
                                                <Icon style={{ paddingTop: "6px" }}>keyboard_arrow_left</Icon>Back
                                            </p>
                                        </Button>
                                        <h4 className="ml-3">User Info</h4>
                                    </div>

                                    <div className="d-flex justify-content-end mt-3">
                                        <div className="d-flex bd-highlight">
                                            <div className="flex-grow-1 bd-highlight">

                                            </div>
                                            <div className="bd-highlight ml-4">
                                                {/* <form className="form-inline">
                                                    <div className="d-flex align-items-center">
                                                        <div className="position-absolute mx-2"><SearchIcon></SearchIcon></div>
                                                       
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="inlineFormInputGroup"
                                                            placeholder="search"
                                                            style={{ "border": "1px solid #ced4da", paddingLeft: "2.25rem" }}
                                                            // onChange={(e) => handleSearch(e)}
                                                        />
                                                    </div>
                                                    <Button variant="light" className="ml-2 border d-flex align-items-center" onClick={goCreateRole}>
                                                        <AddIcon></AddIcon> <span className='ml-2'>
                                                            Create Group</span>
                                                    </Button>
                                                    <Button variant="light" className="ml-2 border" onClick={goCreateRole}>
                                                        <FileDownload></FileDownload>
                                                        <span className='ml-2'>
                                                            Export</span>
                                                    </Button>
                                                    <div className="form-group mx-sm-3 mb-2">

                                                    </div>
                                                </form> */}

                                            </div>
                                        </div>
                                    </div>

                                </div> : <p>เลือกแอพเมนูด้านซ้าย</p>
                            )
                                : ''}
                        </div >
                        <div className='row'>
                            <div className='col-md-8'>
                                <Media className='border-bottom mb-4 justify-content-between'>
                                    {/* <div className="d-flex justify-content-between border-bottom py-2"> */}
                                    <Media.Body>
                                        <h5>{user ? user.name : ''}</h5>
                                        <p><Badge variant="light">Employee ID</Badge>{user ? user.employeeid : ''}</p>
                                    </Media.Body>
                                    <Button
                                        variant="outline-light"
                                        className='border border-dark-50 text-danger'
                                        onClick={() => handleDeleteAcc(user)}
                                    >Delete Account</Button>
                                </Media>
                                <Media className=''>
                                    <Media.Body>
                                        <h5>Group</h5>
                                        <ListGroup className="border-0">

                                            {user ? user.super_role === Roles.SUPER ? (
                                                <TableContainer>
                                                    <Table
                                                        aria-labelledby="tableTitle"
                                                        size={'medium'}
                                                        aria-label="enhanced table"
                                                    >
                                                        <TableRow>
                                                            <TableCell colSpan={6} className="text-center">
                                                                <img
                                                                    width={40}
                                                                    height={40}
                                                                    className="m-3"
                                                                    src={ic_files_empathy}
                                                                    alt="Generic placeholder"
                                                                />
                                                                {user ? user.super_role === Roles.SUPER ? <p> Super User</p> : <p>ยังไม่มีข้อมูล</p> : ''}
                                                            </TableCell>
                                                        </TableRow>
                                                    </Table>
                                                </TableContainer>
                                            ) :
                                                groups.length > 0 ? (

                                                    groups.map((g, index) => {
                                                        return (
                                                            <ListGroup.Item key={index} className='border-0 px-0'>
                                                                <div className="d-flex justify-content-between border-bottom py-2">
                                                                    <div className="">{g.name}</div>
                                                                    {console.log(g)}
                                                                    <DropdownButton
                                                                        menuAlign="right"
                                                                        id={`table-dropdown dropdown-menu-align-right-${index}`}
                                                                        title={<MoreVertIcon></MoreVertIcon>}
                                                                        className='table-dropdown rounded-circle px-1 py-0 bg-transparent' variant="light"
                                                                    >
                                                                        <Dropdown.Item eventKey="1"
                                                                            onClick={() => handleGroup(g)}
                                                                        >Remove group</Dropdown.Item>

                                                                    </DropdownButton>
                                                                </div>
                                                            </ListGroup.Item>
                                                        )
                                                    })

                                                ) : (
                                                    <TableContainer>
                                                        <Table
                                                            aria-labelledby="tableTitle"
                                                            size={'medium'}
                                                            aria-label="enhanced table"
                                                        >
                                                            <TableRow>
                                                                <TableCell colSpan={6} className="text-center">
                                                                    <img
                                                                        width={40}
                                                                        height={40}
                                                                        className="m-3"
                                                                        src={ic_files_empathy}
                                                                        alt="Generic placeholder"
                                                                    />
                                                                    {user ? user.super_role === Roles.SUPER ? <p> Super User</p> : <p>ยังไม่มีข้อมูล</p> : ''}
                                                                </TableCell>
                                                            </TableRow>
                                                        </Table>
                                                    </TableContainer>
                                                )
                                                : ''}

                                        </ListGroup>
                                    </Media.Body>
                                </Media>
                            </div>
                            <div className='col-md-4'>
                                <Media className='border-bottom mb-1'>
                                    <Media.Body>
                                        <h5>Permission Web App</h5>
                                    </Media.Body>
                                </Media>
                                <ListGroup className="border-0">
                                    {user ? groups.length > 0 ? (

                                        // eslint-disable-next-line array-callback-return
                                        user ? user.super_role === Roles.SUPER ? (
                                            <TableContainer>
                                                <Table
                                                    aria-labelledby="tableTitle"
                                                    size={'medium'}
                                                    aria-label="enhanced table"
                                                >
                                                    <TableRow>
                                                        <TableCell colSpan={6} className="text-center">
                                                            <img
                                                                width={40}
                                                                height={40}
                                                                className="m-3"
                                                                src={ic_files_empathy}
                                                                alt="Generic placeholder"
                                                            />
                                                            {user ? user.super_role === Roles.SUPER ? <p> Permission All App</p> : <p>ยังไม่มีข้อมูล</p> : ''}
                                                        </TableCell>
                                                    </TableRow>
                                                </Table>
                                            </TableContainer>
                                        ) : user ? user.super_role === Roles.SUPER ? (
                                            <TableContainer>
                                                <Table
                                                    aria-labelledby="tableTitle"
                                                    size={'medium'}
                                                    aria-label="enhanced table"
                                                >
                                                    <TableRow>
                                                        <TableCell colSpan={6} className="text-center">
                                                            <img
                                                                width={40}
                                                                height={40}
                                                                className="m-3"
                                                                src={ic_files_empathy}
                                                                alt="Generic placeholder"
                                                            />
                                                            {user ? user.super_role === Roles.SUPER ? <p> Permission All App</p> : <p>ยังไม่มีข้อมูล</p> : ''}
                                                        </TableCell>
                                                    </TableRow>
                                                </Table>
                                            </TableContainer>
                                        ) : groups.map((g, index) => {
                                            return (
                                                g.apps.map((app, i) => {
                                                    return (
                                                        <ListGroup.Item key={i} className='border-0 px-0'>
                                                            <Media className='d-flex align-items-center'>
                                                                <img
                                                                    width={36}
                                                                    height={40}
                                                                    className="mr-3"
                                                                    src={app.route.icon}
                                                                    alt={app.route.name}
                                                                />
                                                                <Media.Body>
                                                                    <h5 className='mb-0'>{app.route.name}</h5>
                                                                    <p className='mb-0'>
                                                                        {app.permission.name}
                                                                    </p>
                                                                </Media.Body>
                                                            </Media>
                                                        </ListGroup.Item>
                                                    )
                                                }))
                                        })
                                            : ''
                                            : ''
                                    ) : (
                                        <TableContainer>
                                            <Table
                                                aria-labelledby="tableTitle"
                                                size={'medium'}
                                                aria-label="enhanced table"
                                            >
                                                <TableRow>
                                                    <TableCell colSpan={6} className="text-center">
                                                        <img
                                                            width={40}
                                                            height={40}
                                                            className="m-3"
                                                            src={ic_files_empathy}
                                                            alt="Generic placeholder"
                                                        />
                                                        {user ? user.super_role === Roles.SUPER ? <p> Permission All App</p> : <p>ยังไม่มีข้อมูล</p> : ''}
                                                    </TableCell>
                                                </TableRow>
                                            </Table>
                                        </TableContainer>
                                    )
                                        : ''}

                                </ListGroup>
                            </div>
                        </div>
                    </main>
                </div >
            </div >

            {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        
      </div > */}
        </>

    )
}
export default UserDetail